<template>
  <b-container>
  </b-container>
</template>

<script>

export default {
  name: "Payment",
}
</script>

<style scoped>

</style>